function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import "./week-progress.scss";
import template from "./week-progress.html";

export var WeekProgressComponent = {
  template: template,
  bindings: {
    date: "@",
    week: "@",
    value: "<",
    list: "<" },

  controller: /*#__PURE__*/function () {WeekProgressComponentController.$inject = ["LayoutService"];
    function WeekProgressComponentController(LayoutService) {
      "ngInject";_classCallCheck(this, WeekProgressComponentController);
      this.LayoutService = LayoutService;
      console.log(this);
    }_createClass(WeekProgressComponentController, [{ key: "$onInit", value: function $onInit()

      {
        console.warn('fix it ^');
      } }, { key: "$onChanges", value: function $onChanges(_ref)

      {var value = _ref.value;
        this.updateSmile();
      } }, { key: "updateSmile", value: function updateSmile()

      {
        this.value > 70 && this.value <= 100 ?
        this.curveSmile = this.value / 100 * 5 :
        this.value < 40 && this.value >= 0 ?
        this.curveSmile = this.value / 100 * 5 - 5 :
        this.curveSmile = 0;
      } }]);return WeekProgressComponentController;}() };